import { render, staticRenderFns } from "./NoStartedLive.vue?vue&type=template&id=01bee204&scoped=true"
import script from "./NoStartedLive.vue?vue&type=script&lang=js"
export * from "./NoStartedLive.vue?vue&type=script&lang=js"
import style0 from "./NoStartedLive.vue?vue&type=style&index=0&id=01bee204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bee204",
  null
  
)

export default component.exports